// This right here is my baby. I don't like normal JavaScript alerts because they
// interrupt the WHOLE page and it doesn't look pretty.
// So this is a SnackAlert, which combines a Snackbar and an Alert (and a dialog, but meh).
// A SnackAlert is a component that displays PRETTY looking alerts to a Snackbar located at the
// bottom of the screen. Alerts have severity and an optional dialog message available when a
// "Details" button is pressed.

import React, {Component} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, Snackbar} from '@material-ui/core';
import {Alert} from '@material-ui/lab';

interface AlertProps {
    message: string;
    severity: 'error' | 'info' | 'success' | 'warning';
    open: boolean;
    onChange(): void;
    dialogMessage: string;
    dialogTitle: string;
}

interface AlertState {
    openDialog: boolean;
}

class SnackAlert extends Component<AlertProps, AlertState> {

    constructor(props: AlertProps) {
        super(props);
        this.state = {
            openDialog: false
        };
    }

    openDialog = () => {
        this.setState({
            openDialog: true
        });
    };

    closeDialog = () => {
        this.setState({
            openDialog: false
        });
    };

    handleOnClose = () => {
        this.props.onChange();
    };

    render() {
        return (
            <div>
                <Snackbar
                    open={this.props.open}
                    autoHideDuration={2000}
                    onClose={this.handleOnClose}
                    message={this.props.message}
                >
                    <Alert
                        onClose={this.handleOnClose}
                        severity={this.props.severity}
                    >
                        {this.props.message}
                        {this.props.dialogMessage !== "" ?
                            <Button onClick={this.openDialog}>
                                More Details
                            </Button> : ""
                        }
                    </Alert>
                </Snackbar>
                <Dialog open={this.state.openDialog}>
                    <DialogTitle>
                        {this.props.dialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        {this.props.dialogMessage.split("\n").map((line: string) => {
                            return <p>{line}</p>
                        })}
                    </DialogContent>
                    <DialogContent>
                        <Button onClick={this.closeDialog}>
                            DISMISS
                        </Button>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

export default SnackAlert